import axios from 'axios';
import type {
  IGetInvoiceHistoryQuery,
  IGetInvoiceHistoryResponse,
} from '@/app-package';

export const getInvoiceHistory = async (query: IGetInvoiceHistoryQuery) => {
  const { data } = await axios.get<IGetInvoiceHistoryResponse>(
    `/billing/invoice_history`,
    {
      params: {
        supraOCN: query.supraOCN,
        billingCustomerNumber: query.billingCustomerNumber,
      },
    },
  );

  return data;
};

export default getInvoiceHistory;
